import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "WatchAnalog.svg",
  "use": "WatchAnalog.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"WatchAnalog.svg\"><path d=\"M40,45.842V53a3,3,0,0,1-3,3H27a3,3,0,0,1-3-3V45.842a15.9751,15.9751,0,0,1,0-27.684V11a3,3,0,0,1,3-3H37a3,3,0,0,1,3,3v7.158a15.9751,15.9751,0,0,1,0,27.684ZM32,20A12,12,0,1,0,44,32,12,12,0,0,0,32,20Zm5.5383,16.8987L30.92,33.6922a1.6234,1.6234,0,0,1-.9049-1.6368l.0057-.0475,1.01-9.1088a1.0155,1.0155,0,0,1,2.0192,0l.9011,8.1278,4.7075,4.1874a1.0211,1.0211,0,0,1-1.12,1.6841Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol